import { Col, Row } from "react-bootstrap";
import LicenceProfileHeader from "../../LicenceProfileHeader";
import LicenceProfileSubTabs from "../../LicenceProfileSubTabs";
import BreadCrumbs from "./BreadCrumbs";
import { useParams } from "react-router-dom";
import RelatedComplianceRecords from "./RelatedComplianceRecords";
import Page404 from "../../../../pages/auth/Page404";
import useAppSelector from "../../../../hooks/useAppSelector";
import {
  loadLicenceProfileAsync,
  selectLicenceProfileResponse,
} from "../../../../redux/slices/licenceProfile";
import useAppDispatch from "../../../../hooks/useAppDispatch";
import Loading from "../../../../leap-components/Loading";
import BackToCompliance from "../../ComplianceTab/BackToCompliance";
import { useState } from "react";
import {
  GetLicenceProfileNotReadyComponent,
  IsLicenceProfileReady,
} from "../../../../leap-components/LicenceProfile/LicenceProfileResponseComponentFactory";
import { ILicenceProfile } from "../../../../api/ILicenceProfile";
import ActionOrInstructionHeader from "./ActionOrInstructionHeader";
import ActionOrInstructionDetails from "./ActionOrInstructionDetails";
import {
  loadActionOrInstructionAsync,
  selectActionOrInstruction,
} from "../../../../redux/slices/actionOrInstruction";

const ActionOrInstruction = () => {
  const [loading, setLoading] = useState(false);
  const [loadingActionOrInstructionId, setLoadingActionOrInstructionId] =
    useState("");
  const licenceProfileSelector = useAppSelector(selectLicenceProfileResponse);
  const actionOrInstructionSelector = useAppSelector(selectActionOrInstruction);

  const dispatch = useAppDispatch();

  let { profileNo, actionOrInstructionId } = useParams();
  if (!profileNo || !actionOrInstructionId) {
    return <Page404 />;
  }

  if (!loading) {
    setLoading(true);
    dispatch(loadLicenceProfileAsync(profileNo));
  }

  if (!IsLicenceProfileReady(licenceProfileSelector.licenceProfileResponse)) {
    return GetLicenceProfileNotReadyComponent(
      licenceProfileSelector.licenceProfileResponse
    );
  }

  const licenceProfile = licenceProfileSelector.licenceProfileResponse
    ?.licenceProfile as ILicenceProfile;

  if (loadingActionOrInstructionId !== actionOrInstructionId) {
    setLoadingActionOrInstructionId(actionOrInstructionId);
    dispatch(loadActionOrInstructionAsync(actionOrInstructionId));
    return <Loading />;
  }

  const actionOrInstruction = actionOrInstructionSelector.actionOrInstruction;

  if (!actionOrInstruction) {
    return <Loading />;
  }

  const contentElement = (
    <div>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <ActionOrInstructionHeader
            actionOrInstruction={actionOrInstruction}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <ActionOrInstructionDetails
            actionOrInstruction={actionOrInstruction}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <RelatedComplianceRecords
            licenceProfile={licenceProfile}
            actionOrInstruction={actionOrInstruction}
          />
        </Col>
      </Row>
    </div>
  );

  return (
    <div>
      <BreadCrumbs
        licenceProfile={licenceProfile}
        actionOrInstruction={actionOrInstruction}
      />
      <div className="ps-0">
        <LicenceProfileHeader licenceProfile={licenceProfile} />
        <LicenceProfileSubTabs
          activeKey="compliance-records"
          content={contentElement}
          licenceProfile={licenceProfile}
        />
      </div>
    </div>
  );
};

export default ActionOrInstruction;
